import { render, staticRenderFns } from "./zuomian.vue?vue&type=template&id=164130af&scoped=true&"
import script from "./zuomian.vue?vue&type=script&lang=js&"
export * from "./zuomian.vue?vue&type=script&lang=js&"
import style0 from "./zuomian.vue?vue&type=style&index=0&id=164130af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164130af",
  null
  
)

export default component.exports